import React, { useMemo, useState } from 'react';
import { TableColumn, Tag } from 'tea-component';
import {
  // genreCreatorListTagsColorMap,
  influenceListColumnsMap,
} from '../constants';
import BubbleCommon, {
  influencerSegmentationAndTagTableTips,
} from '@/pages/opinion/components/BubbleCommon';
import { arrayToObj, transRegion } from '@/pages/opinion/utils';
import HoverSortCommon from '@/pages/opinion/components/HoverSortCommon';
import { useIntl } from 'umi';
import SvgIcon from '@home/components/SvgIcon';
import { NO_DATE } from '@op/constants';
import {
  ChartTableElement,
  GameCoveredElement,
  getInfluencerElement,
  ValueTableElement,
} from './components/TableColumns';
import TableMultipleSelectFilter from '@op/components/TableMultipleSelectFilter';
import {
  IInfluencerTags,
  InfluencerExtraTags,
} from '../components/InfluenceExtraTags';
import CommonBubble from '@home/components/CommonBubble';
// 指标列宽度
const columnsWidth = '200px';

export default function useInfluenceListColumns({
  linkTime,
  mediaType,
  selectKeys,
  selectedKeysMap,
  sort,
  changeSortInfo,
  progressVisible,
  isAuto,
  tags,
  setTags,
  tagList,
  gameInfo,
}: any) {
  const { formatMessage } = useIntl();
  const [displayShowAllTagsButton, setDisplayShowAllTagsButton] =
    useState(false);
  const [showAllTags, setShowAllTags] = useState(false);

  const genreCreatorListTagsColorMap = useMemo(
    () => arrayToObj(tagList, 'key'),
    [tagList],
  );
  // 表格的Columns 和 排序的key
  const [tableColumns, sortKeys]: [TableColumn<any>[], Array<string>] =
    useMemo(() => {
      const options = tagList
        ?.filter((item: { no_filter: any; }) => !item?.no_filter)
        ?.map((item: { text: any; key: any; }) => ({
          text: item.text,
          value: item.key,
        }));
      const resultList: TableColumn<any>[] = [
        getInfluencerElement({
          formatMessage,
          isAuto,
          transRegion,
          influencerTips: null,
          valueKeyList: [
            { key: 'avatar', valueKey: 'cover' },
            { key: 'user_id', valueKey: 'author_md5' },
            { key: 'name', valueKey: 'author_name' },
            { key: 'url', valueKey: 'author_url' },
            { key: 'channel', valueKey: 'channel_name' },
            { key: 'language' },
            { key: 'country' },
          ],
        }),
        {
          key: 'tags',
          width: 360,
          header: (
            <div className="dbo-influencer-table-tags-header">
              <TableMultipleSelectFilter
                options={options}
                value={tags}
                onChange={setTags}
                listWidth={'auto'}
                listHeight={185}
                needFormatMessage={false}
                button={(icon) => (
                  <div className={`tag-filter-box ${tags?.length !== options?.length && 'active'}`}  >
                    <SvgIcon type="new-logo"></SvgIcon>
                    {formatMessage({ id: 'Segmentation & Tags' })}
                    {icon}
                    <BubbleCommon
                      placement="top"
                      tipsMap={influencerSegmentationAndTagTableTips}
                    ></BubbleCommon>
                  </div>
                )}
              />
              {displayShowAllTagsButton && (
                <span
                  className="button-text"
                  onClick={() => setShowAllTags(!showAllTags)}
                >
                  {showAllTags
                    ? formatMessage({ id: 'Collapse' })
                    : formatMessage({ id: 'Show all tag' })}
                </span>
              )}
            </div>
          ),
          render: ({ tags, ext_tags }) => {
            if (
              (!Array.isArray(tags) || tags.length === 0) &&
              (!Array.isArray(ext_tags) || ext_tags.length === 0)
            )
              return '-';

            const tagsView =
              tags
                ?.map((item: string, index: number) => {
                  const itemInfo = genreCreatorListTagsColorMap?.[item];
                  if (!itemInfo) return null;
                  const { color, text, bgColor, key } = itemInfo;
                  return {
                    id: key,
                    element: (
                      <Tag
                        className="tag-item"
                        key={key}
                        style={{ color, backgroundColor: bgColor }}
                      >
                        {text || formatMessage({ id: NO_DATE.EMPTY })}
                      </Tag>
                    ),
                  };
                })
                .filter((val: React.ReactNode) => val !== null) || [];

            const extTagsView =
              ext_tags
                ?.map((item: { name: string; tags: IInfluencerTags[] }) => {
                  const { name, tags } = item;
                  const itemInfo = genreCreatorListTagsColorMap?.[name];
                  if (!itemInfo) return null;
                  const { color, text, bgColor, key } = itemInfo;

                  return {
                    id: key,
                    element: (
                      <InfluencerExtraTags
                        tags={tags}
                        name={name}
                        key={key}
                        color={color}
                        backgroundColor={bgColor}
                        text={text}
                      />
                    ),
                  };
                })
                .filter((val: React.ReactNode) => val !== null) || [];

            // 避免未加入的新tags 渲染空白
            const allTagsViews =
              tagsView.length || extTagsView.length
                ? [...tagsView, ...extTagsView]
                : '-';
            if (allTagsViews === '-') return <>{allTagsViews}</>;
            if (allTagsViews.length > 4 && !displayShowAllTagsButton) {
              setDisplayShowAllTagsButton(true);
            }
            if (!showAllTags) {
              return (
                <>
                  {allTagsViews.slice(0, 4).map((val) => val.element)}
                  {allTagsViews.length > 4 && (
                    <CommonBubble
                      content={
                        <>
                          {allTagsViews.slice(4).map((val) => {
                            const { id } = val;
                            const itemInfo = genreCreatorListTagsColorMap[id];
                            if (!itemInfo) return null;
                            return (
                              <div key={itemInfo.key}>
                                {itemInfo.text ||
                                  formatMessage({
                                    id: NO_DATE.EMPTY,
                                  })}
                              </div>
                            );
                          })}
                        </>
                      }
                    >
                      <Tag
                        className="tag-item"
                        style={{
                          color: 'rgb(106, 109, 126)',
                          backgroundColor: 'rgb(235, 236, 241)',
                        }}
                      >
                        +{allTagsViews.length - 4}
                      </Tag>
                    </CommonBubble>
                  )}
                </>
              );
            }
            return <>{allTagsViews.map((val) => val.element)}</>;
          },
        },
      ];
      const sortKeys: Array<string> = [];
      influenceListColumnsMap(gameInfo).forEach(
        ({
          key,
          header,
          tips,
          width,
          showChart,
          align = 'right',
          showGame,
          haveSort = true,
          isPercentage,
          showRatio = true,
        }: any) => {
          let headerInfo = (
            <BubbleCommon placement="top" tipsMap={tips} showIcon={false}>
              <div className="dbo-influencer-table-header">
                {formatMessage({ id: header })}
              </div>
            </BubbleCommon>
          );
          if (key !== 'followers_grow') {
            haveSort && sortKeys.push(key);
          } else {
            headerInfo = (
              <HoverSortCommon
                className="tea-text-rightfollowers-grow"
                sort={sort}
                sortOptions={[
                  {
                    text: formatMessage({
                      id: 'Sort influencers with more than 5K followers (faster)',
                    }),
                    value: 'followers_grow_more_5k',
                  },
                  {
                    text: formatMessage({
                      id: 'Sort all influencers (time-consuming)',
                    }),
                    value: 'followers_grow',
                  },
                ]}
                sortChange={(sort: { by: string; order: 'asc' | 'desc' }) =>
                  changeSortInfo(sort)
                }
              >
                {headerInfo}
              </HoverSortCommon>
            );
          }

          resultList.push({
            key,
            width: width || columnsWidth,
            header: headerInfo,
            align,
            render: (item: { [x: string]: any }) => {
              if (showChart) {
                return (
                  <ChartTableElement
                    valueKey={key}
                    item={item}
                    title={header}
                  ></ChartTableElement>
                );
              }
              if (showGame) {
                return (
                  <GameCoveredElement
                    data={item.tweets_games_details}
                  ></GameCoveredElement>
                );
              }
              return (
                <ValueTableElement
                  valueKey={key}
                  item={item}
                  title={header}
                  showRatio={showRatio}
                  isPercentage={isPercentage}
                  linkTime={linkTime}
                  progressVisible={progressVisible}
                ></ValueTableElement>
              );
            },
          });
        },
      );
      return [resultList, sortKeys];
    }, [
      isAuto,
      mediaType,
      selectKeys,
      linkTime,
      sort,
      progressVisible,
      formatMessage,
      tags,
      displayShowAllTagsButton,
      showAllTags,
    ]);

  // 获取className
  const getClassName = (rowKey: string | number) => {
    const key = selectedKeysMap[rowKey]?.color || '';
    return `color-${key?.substring(1)}`;
  };

  return {
    tableColumns,
    sortKeys,
    getClassName,
  };
}
